import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
import { theme } from 'theme/App.theme';

const colors = appPalette.colors;

function focusableStyles(offset: number) {
  return {
    outline: `0.125rem solid`,
    outlineOffset: `.${offset}rem`,
  };
}

export const useStyles = makeStyles({
  root: {
    display: 'block',
    paddingBottom: '1.875rem',

    '&.mobile-hidden': {
      display: 'none',
      [theme.breakpoints.up('viewportLarge')]: {
        display: 'block',
      },
    },
  },
  zip_input_button: {
    alignItems: 'center',
    background: colors.white,
    border: `0.0625rem solid ${colors.mid_grey_2}`,
    borderRadius: 0,
    cursor: 'pointer',
    color: colors.dark_grey_2,
    fontSize: '0.875rem',
    display: 'flex',
    height: '3.125rem',
    justifyContent: 'flex-start',
    padding: '0 1rem',
    position: 'relative',
    width: '100%',
    zIndex: 1,
    ...(theme.themeName === 'honda' && {
      borderRadius: '0.25rem',
    }),
    '&:hover': {
      backgroundColor: colors.white,
    },
    '&:focus': {
      '&> span': {
        '&>.cta-focusable': {
          ...focusableStyles(3),
          outlineColor: colors.black,
        },
      },
    },
    '& svg': {
      width: '0.9375rem',
      height: '0.9375rem',
      marginRight: '0.5rem',
    },
    '&.Mui-focusVisible': {
      outline: '0.125rem solid',
      outlineOffset: 0,
      outlineColor: colors.black,
    },
  },
  is_form_open: {
    background: colors.light_grey_1,
    color: colors.white,
    '& svg': {
      fill: colors.white,
    },

    '&:hover': {
      backgroundColor: colors.light_grey_1,
    },
  },
  zip_input: {
    display: 'flex',
    height: '3.125rem',
    width: 'calc(100% - 2.25rem)',
    '& input': {
      background: colors.white,
      height: '1.75rem',
      border: `0.0625rem solid ${colors.mid_grey_2}`,
      padding: '0.625rem 2.25rem 0.625rem 0.75rem',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 'normal',
      '&::placeholder': {
        color: ` ${colors.dark_grey_2} !important`,
        opacity: 1,
      },

      '&.error': {
        border: 'solid #e82c2a 0.1875rem',
        borderRight: 0,
        height: '1.5rem',
      },
      '&.MuiInputBase-input:focus': {
        'body:not(.acr-focus-disabled) &': {
          zIndex: 2,
          ...focusableStyles(0),
          outlineColor: colors.black,
        },
      },
    },
  },
  focusable: {
    outline: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 2,
  },
  form_button: {
    alignItems: 'center',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.3125rem 1.3125rem',
    background: colors.light_grey_5,
    border: 0,
    color: 'transparent',
    display: 'inline-flex',
    height: '3.125rem',
    justifyContent: 'center',
    right: 0,
    borderRadius: 0,
    width: '2.25rem',
    zIndex: 1,
    '& svg': {
      width: '0.9375rem',
      height: '0.9375rem',
    },
    '&:hover': {
      backgroundColor: colors.light_grey_5,
    },

    '&.is-enabled': {
      backgroundColor: colors.acura_red,
    },
    '& .cta-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
    },
  },
  spinner: {
    background: colors.light_grey_5,
    position: 'absolute',
    zIndex: 10,
    height: '2.25rem',
    width: '2.25rem',
    '&:before': {
      animation: '$slide-spin .75s linear infinite',
      borderRadius: '50%',
      borderRight: '0.125rem solid transparent',
      borderTop: `0.125rem solid ${colors.white}`,
      content: "''",
      height: '1.5625rem',
      width: '1.5625rem',
      position: 'absolute',
      boxSizing: 'border-box',
      left: '0.375rem',
      top: '0.3125rem',
    },
  },
  error: {
    alignItems: 'center',
    background: colors.white,
    color: colors.acura_red,
    height: '1.875rem',
    padding: '0.3125rem 0.9375rem',
    position: 'relative',
    width: '100%',
  },
  show_grid: {
    display: 'flex',
  },
  hide_grid: {
    display: 'none',
  },
  '@keyframes slide-spin': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
});
